import { React, useState } from 'react'
import {
    ClipboardCopyIcon
  } from '@heroicons/react/outline'

function Commands() {
    const [clicked, setClicked] = useState(false);
    const commands = [
        { name: '8ball', desc: 'Ask a yes or no question, have it answered.' },
        { name: 'activeusers', desc: 'See a list of active users.' },
        { name: 'assemble', desc: 'Assemble the bruvs.' },
        { name: 'audio', desc: 'List of audiofiles.' },
        { name: 'audiostats', desc: 'See the top played audiofiles.' },
        { name: 'boomer', desc: '!boomer boomername' },
        { name: 'boomers', desc: 'Get a list of boomer points' },
        { name: 'coin', desc: '!coin coinname' },
        { name: 'faketime', desc: 'Not even a real timezone.' },
        { name: 'fantasy', desc: 'Get fantasy stats.' },
        { name: 'google', desc: '!google search query.' },
        { name: 'hydraslayer', desc: 'Nice try.' },
        { name: 'imdb', desc: '!imdb movie name' },
        { name: 'play', desc: '!play hydra-slayer.' },
        { name: 'randompin', desc: 'Display a random pin.' },
        { name: 'randomplay', desc: 'Randomly play an audio file.' },
        { name: 'realtime', desc: 'The realest of times.' },
        { name: 'reddit', desc: '!reddit subreddit' },
        { name: 'removeactive', desc: 'Remove yourself as active.' },
        { name: 'roll', desc: '!roll number - to roll the dice.' },
        { name: 'setactive', desc: 'Set yourself to active.' },
        { name: 'stock', desc: '!stock companyname.' },
        { name: 'tgkmovies', desc: 'Get a list of tgk movies.' },
        { name: 'vote', desc: 'Create a vote.' },
        { name: 'weather', desc: 'Get the weather by zip code.' },
        { name: 'youtube', desc: 'YouTube link to a video.' },
    ];

    function changeIconClasses(file) {
        setClicked(file)
        setTimeout( () => { setClicked('false') }, 250)
    }

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 className="text-2xl font-semibold text-gray-900">Bot Commands</h1>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="my-4">
          <div className="full-table-height overflow-hidden overscroll-contain overflow-y-auto scroll-custom rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50 sticky top-0 shadow-sm z-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Command
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {commands.map( ( command, index ) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{command.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <div className="relative">
                        <ClipboardCopyIcon 
                          onClick={
                            () => {
                              navigator.clipboard.writeText(`!${command.name}`)
                              changeIconClasses(command.name)
                            }
                          }
                          className={clicked === command.name ? 'h-5 w-5 ml-6 text-green-500 cursor-pointer' : 'h-5 w-5 ml-6 text-blue-500 cursor-pointer'}
                        />
                        <span 
                          onClick={() => {changeIconClasses(command.name)}}
                          className={clicked === command.name ? 'absolute p-2 bg-white rounded-lg shadow-md text-xs left-14 bottom-0 opacity-1' : 'absolute p-2 bg-white rounded-lg shadow-md text-xs left-14 bottom-0 opacity-0 pointer-events-none transition'}
                        >
                          Copied to clipboard
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{command.desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Commands